import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import MyNothing from '../../template/MyNothing';

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import AXIOS from '../../api/axios';
import clientApi from '../../api/client';
import dayjs from 'dayjs';
import { apiDefine } from "../../api/web";

import './style.less';


const colors = ['#00a0ff', '#FFCE65'];

const option = {
    grid: {
        left: "1%",
        right: "2%",
        bottom: "3%",
        top: "20%", // 顶部空出20%的空间，来显示legend
        containLabel: true 
    },
    legend: {
        left: "right", // 像右对齐
        top: '5%',
        itemGap: 20,
        textStyle: {
            fontSize: 14
        },
        selectedMode: false
    },
    tooltip: {
        show: true,
        trigger: 'axis',
        formatter: 
        `
            <div class="tips-title">{b}学习时长</div>
            <div class="tips-item item1">
                <span class="tips-circle" style="border-color: #00a0ff"></span>
                <span>{c0}分钟</span>
            </div>
            <div class="tips-item item2">
                <span class="tips-circle" style="border-color: #FFCE65"></span>
                <span>{c1}分钟</span>
            </div>
        `,
        padding: [6,12],
        backgroundColor: 'rgba(0,0,0,0.64)',
        axisPointer: {
            type: 'line',
            z: 1,
            lineStyle: {
                color: '#ccc'
            }
        }
    },
    xAxis: {
        type: 'category',
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel : {
            margin: 20,
            textStyle: {
                color: '#999'
            }
        }
    },
    yAxis: {
        type: 'value',
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        splitLine: {
            lineStyle: {
                color: ['#efefef']
            }
        },
        axisLabel : {
            textStyle: {
                color: '#999'
            }
        }
    },
    series: [
        {
            type: 'line',
            color: colors[0],
            showSymol: true,
            symbolSize: 8,
            z: 3,
            lineStyle: {
                width: 3
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0, 160, 255, 0.38)'
                }, {
                    offset: 1,
                    color: 'rgba(255, 255, 255, 0.16)'
                }])
            }
        },
        {
            name: '平台用户平均值',
            type: 'line',
            color: colors[1],
            showSymol: true,
            symbolSize: 8,
            z: 2,
            lineStyle: {
                width: 3
            }
        }
    ],
    textStyle: {
        fontFamily: 'clientFont'
    }
};

class LearningReport extends Component {

    constructor(){
        super();
        this.state = {
            userId: window.localStorage.getItem('ac_id'),
            num: 1,
            row: 7,
            interval: 30,
            noMore: false,
            list: []
        }
        document.title = '学习报告'
    }

    componentDidMount(){
        const { userId, interval } = this.state;
        const mychart = echarts.init(this.chart);
        apiDefine({apiName:'refresh',fn:this.refresh}); // 定义刷新数据接口
        AXIOS.getLearningReport({ query: userId }, (res, err) => {
            if(err){
                console.log('err', err)
            }
            else {
                const { recentStudy } = res;
                let xData = [], durationList = [], avgDurationList = [];
                recentStudy.forEach((ele) => {
                    xData.push(dayjs(ele.classDate).format('MM/DD'));
                    durationList.push(ele.duration || 0);
                    avgDurationList.push(ele.avgDuration || 0);
                })
                const newOption = {
                    ...option,
                    xAxis: {
                        ...option.xAxis,
                        data: xData
                    },
                    yAxis: {
                        ...option.yAxis,
                        minInterval: interval,
                        maxInterval: interval
                    },
                    series: [
                        {
                            ...option.series[0],
                            name: res.stuEnName,
                            data: durationList
                        },
                        {
                            ...option.series[1],
                            data: avgDurationList
                        }
                    ]
                }
                mychart.setOption(newOption);
            }
        });
        this.getData();
    }

    handleClick = (index) => {
        const { list } = this.state;
        const info = list[index];
        if(!info) return;
        clientApi.showLessonDetail({...info});
    }

    handleBottom = (visibility) => {
        if(visibility){
            setTimeout(this.getData, 2000);
        }
    }

    refresh = () => {
        const { userId, list } = this.state;
        AXIOS.getLearningRecent({ data: { stuId: userId, row: list.length, num: 1 } }, (res, err) => {
            if(err){
                console.log(err.errorCode)
            }
            else {
                this.setState({
                    list: res
                });
            }
        })
    }
    getData = () => {
        const { row, num, noMore, userId } = this.state;
        if(noMore) return;
        AXIOS.getLearningRecent({ data: { stuId: userId, row, num } }, (res, err) => {
            if(err){

            }
            else {
                if(res.length){
                    this.setState({
                        num: this.state.num + 1,
                        list: this.state.list.concat(res),
                        showSensor: true,
                    });
                }
                else{
                    this.setState({
                        showSensor: true,
                        noMore: true
                    });
                }
            }
        })
    }

    render(){
        const { list, noMore, showSensor } = this.state;
        const listLength = list.length;
        return(
            <div className='learningReport'>
                <div className='button'>近七日学习时长(分)</div>
                <div className='char'>
                    <div className='chartsWrap' ref={ dom => this.chart = dom } />
                    <div className='span'>每天24:00更新当天的学习时长</div>
                </div>
                <div className='button'>上课记录</div>
                <div className='list'>
                    { 
                        !!(showSensor && listLength) && list.map((ele, index)=> (
                            <div className='item' key={ele.classSchId} onClick={this.handleClick.bind(this, index)}>
                                <div 
                                    className='poster'
                                    style={{ backgroundImage: `url(${ele.courseDetailCoverHPhoto})` }}
                                >
                                    <div className={`after ${ele.completeStatus && 'done'}`}>{ele.completeStatus ? '完成' : '未完成'}</div>
                                </div>
                                <div className='info'>
                                    <div className='title'>{ele.courseCnName}</div>
                                    <div className='desc'>{`${ele.courseDetailLevelCnTitle || ''} ${ele.courseDetailUnitCnTitle || ''} ${ele.courseDetailCnName}`}</div>
                                    <div className='date'>上课时间: {dayjs(ele.classStartTime).format('YYYY-MM-DD HH:mm:ss')}</div>
                                </div>
                            </div>
                        ))
                    }
                    {!!(showSensor && !listLength) && <MyNothing text='近一个月，你都没有上课记录哦~' />}
                </div>
                {!!(showSensor && listLength) &&
                    <VisibilitySensor onChange={this.handleBottom}>
                        <div className='tips'>{noMore ? '最多展示一个月的上课记录哦~' : '加载中...' }</div>
                    </VisibilitySensor>
                }
            </div>
        )
    }
}

export default LearningReport;



// WEBPACK FOOTER //
// ./src/components/learningReport/index.js